import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import Hotjar from "vue-hotjar";
import "@/registerServiceWorker";
import store from "@/store";
import Toasted, { toastDefaultOptions } from "@/plugins/Toasted";
import vuetify from "@/plugins/Vuetify";
import { INIT_KEYCLOAK, PLATFORM_GROUP } from "@/store/actions/actions.type";
import ClarityPlugin from "@/plugins/clarity";

import "@/theme/default.scss";
import "@/../public/assets/vendors/material-design/css/materialdesignicons.min.css";
import VueClipboard from "vue-clipboard2";
import moment from "moment";
import { ID_HOTJAR } from "./common/config";

Vue.config.productionTip = false;
store
  .dispatch(`auth/${INIT_KEYCLOAK}`)
  .then(() => {
    initApp();
  })
  .catch(response => {
    console.log(response);
  });

const initApp = function () {
  store.dispatch(`auth/${PLATFORM_GROUP}`);
  let isProductionOrStage =
    process.env.NODE_ENV === "development" ? false : true;

  if (isProductionOrStage) {
    Vue.use(Hotjar, {
      id: ID_HOTJAR,
      isProduction: isProductionOrStage,
      snippetVersion: 6
    });
  }
  Vue.use(ClarityPlugin);
  Vue.use(Toasted, toastDefaultOptions, VueClipboard, moment);

  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount("#app");
};
